import { DevHubTypography } from '@devxdiscover/devhub-ui';

interface ResourceLabelProps {
  /** The resource type for color coding */
  type: 'github' | 'cnap' | 'adGroups';
  /** The label text to display */
  children: React.ReactNode;
  /** Optional className for styling */
  className?: string;
  /** Optional inline styles */
  style?: React.CSSProperties;
}

/**
 * Color-coded label for resource types
 * - GitHub: purple-blue
 * - CNAP: orange-red
 * - AD Groups: blue-green
 * @param props - Component props
 * @param props.type - The resource type for color coding
 * @param props.children - The label text to display
 * @param props.className - Optional className for styling
 * @param props.style - Optional inline styles
 */
export const ResourceLabel = ({
  type,
  children,
  className,
  style,
}: ResourceLabelProps) => {
  const colorMap = {
    github: 'purpleBlue' as const,
    cnap: 'orangeRed' as const,
    adGroups: 'blueGreen' as const,
  };

  return (
    <DevHubTypography
      variant="body2"
      fontColor={colorMap[type]}
      weight="bold"
      className={className}
      style={{
        display: 'block',
        marginBottom: '4px',
        ...style,
      }}
    >
      {children}
    </DevHubTypography>
  );
};
